<template>
  <div class="login-container align-self-center">
    <h1>Dev Portal</h1>
    <b-button
      type="button"
      @click="login"
      variant="secondary">
      Login
    </b-button>
  </div>
</template>

<script>
import Login from './login-page';

export default Login;
</script>

<style lang="scss" scoped>
@import "./login-page.scss";
</style>
